import { contentType } from "../components/api/wiki";
import { Title } from "./TitleParser";

export interface TreeData {
  type: CodeFileType;
  path: string;
  key: string;
  title: string;
  isLeaf: boolean;
  isOpen: boolean;
  loading: boolean;
  children: TreeData[];
}
export enum CodeFileType {
  "tree" = "tree",
  "file" = "file",
}
export const reMadeTree = (arr: TreeData[], parentPath?: string) => {
  // 有子目录的排序在前
  arr.sort((a, b) => {
    if (a.type === CodeFileType.tree && b.type === CodeFileType.file) {
      return -1;
    }
    if (a.type === CodeFileType.file && b.type === CodeFileType.tree) {
      return 1;
    }
    return 0;
  });
  const newArr = arr.map((item, index) => {
    item.path = item.path;
    item.key = item.path;
    item.isOpen = false;
    item.title = item.path.split("/").reverse()[0];
    if (item.type === CodeFileType.tree) {
      item.isLeaf = false;
      item.children = reMadeTree(item?.children || [], parentPath);
    } else {
      // 根据文件的后缀名分配不同的图标
      const suffix = item.title.split(".").reverse()[0];
      item.isLeaf = true;
    }

    return item;
  });
  return newArr;
};

export const findNodeByPath = (
  treeData: TreeData[],
  path: string
): TreeData | undefined => {
  for (let i = 0; i < treeData.length; i++) {
    if (treeData[i].path === path) {
      return treeData[i]; // 找到目标节点，返回
    } else if (treeData[i].children && treeData[i].children.length > 0) {
      // 递归查找子节点
      const result = findNodeByPath(treeData[i].children, path);
      if (result) {
        return result; // 如果子节点中找到目标，返回结果
      }
    }
  }
  return undefined; // 遍历结束未找到，返回 undefined
};
// 检测是否是 Base64 图片
export const isBase64Image = (str: string): boolean => {
  const base64ImageRegex = /^data:image\/(png|jpe?g|gif|svg|webp);base64,/;
  return base64ImageRegex.test(str);
};

export const mergeAnchorsIntoTree = (
  treeData: contentType[],
  anchorData: Title[]
) => {
  // 先做一个快速查找用的 map：标题 -> 锚点数据
  const anchorMap = new Map(anchorData.map((a) => [a.text, a]));

  function mergeNode(node: any) {
    // 如果当前节点在 anchorMap 中找到了锚点数据
    const anchor = anchorMap.get(node.title);
    let children: any[] = [];
    // 递归处理 children
    if (Array.isArray(node.children) && node.children.length > 0) {
      children = node.children.map((child: any) => mergeNode(child));
    } else {
      children = anchor?.children || [];
    }
    if (anchor) {
      // 把锚点的 children 挂到 node 下（保留原有 children 并继续递归）
      return {
        level: anchor.level,
        text: anchor.text,
        id: anchor.id,
        children: children,
      };
    } else {
      return { level: node.level, text: node.title, id: node.uuid, children };
    }
  }

  // 因为 treeData 是数组，逐个处理
  const arr = treeData.map((rootNode) => mergeNode(rootNode));

  return arr;
};
